import { detector } from './detector';
import { getURL, query, build } from '../query';
import { trackLaunchAppEvent, upLaunchAppEvent } from '../webx';
import { trackEvent as track } from '../omega';
import { getNineChapterWebxParams } from '../statistic';
import { bridge } from '../platform/bridge';
import showPassphraseView from './ui/passphrase-ui';
import showGuideView from './ui/user-guide-ui';
import { utils } from '../utils';
const isIos = detector.os.name === 'ios';
const isAndroid = detector.os.name === 'android';
const isIOSWithLocationCallSupport = isIos && detector.browser.name == 'safari' && detector.os.version >= 9;
const isChromeWithLocationCallSupport = detector.browser.name == 'chrome' && detector.browser.version > 55;
const isSamsungWithLocationCallSupport = detector.browser.name == 'samsung';
const isAndroidWithLocationCallSupport = isAndroid && (isChromeWithLocationCallSupport || isSamsungWithLocationCallSupport);
const locationCall = (url) => {
    (top.location || location).href = url;
};
const iframeCall = (url) => {
    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', url);
    iframe.setAttribute('style', 'display:none');
    document.body.appendChild(iframe);
    setTimeout(function () {
        document.body.removeChild(iframe);
    }, 200);
};
let launchAppEnv = 'online';
export const setLaunchAppEnv = (env) => {
    env && (launchAppEnv = env);
};
export const getLaunchAppEnv = () => {
    return launchAppEnv;
};
// 获取拉端方法
export const getOpenMethod = (openType) => {
    return openChannel[openType];
};
// 强制阻断拉端
export const forcePull = (linkObj, browser, extra) => {
    const { linkType, link, extraParam } = linkObj;
    // 埋点：上报拉端事件埋点
    trackLaunchAppAction(getDeepLink(linkObj));
    const openMethod = getOpenMethod(linkTypeToOpenMethodMap[linkType]);
    if (linkType === 7) {
        // 拉起小程序
        openMethod(extraParam, browser);
    }
    else if (linkType === 4) {
        // 下载App
        openMethod(linkObj, extra);
    }
    else {
        // 如果主拉端方式是universal link，并且候补拉端有download，跳转时带上口令
        let url = link;
        if (linkType === 1) {
            const cmd = encodeURIComponent(linkObj.cmd);
            url = build(link, { cmd }, false);
        }
        openMethod && openMethod(url, true);
    }
};
// 拉端类型映射表，落地页曝光或者按钮点击
export const pullEventTypeMap = {
    'LANDPAGE_EXPOSE': '1',
    'BTN_CLICK': '2',
};
// webx服务下发拉端类型映射表
export const pullTypeMap = {
    // 强制拉起
    'FORCE_PULL': 1,
    // 引导拉起
    'GUIDE_PULL': 2,
    // 无动作
    'NO_ACTION': 3,
    // 拉端口令
    'PASSPHRASE': 4,
};
// webx服务下发拉端链接类型对应拉端方法映射表
export const linkTypeToOpenMethodMap = {
    1: 'link',
    2: 'scheme',
    3: 'wx_scheme',
    4: 'download',
    5: 'guide',
    6: 'passphrase',
    7: 'bridge'
};
// 技术埋点与业务埋点映射
export const launchEventIdToOmegaEventIdMap = {
    launch_app_force_pull_popup_expose: {
        eventId: 'userteam_ldfw_force_pull_popup_sw',
        label: '拉端服务-弹窗曝光'
    },
    launch_app_passenger_btn_click: {
        eventId: 'userteam_ldfw_passenger_btn_ck',
        label: '拉端服务-跳转app按钮点击'
    },
    launch_app_mini_btn_click: {
        eventId: 'userteam_ldfw_mini_btn_ck',
        label: '拉端服务-跳转小程序按钮点击'
    },
    launch_app_download_btn_click: {
        eventId: 'userteam_ldfw_download_btn_ck',
        label: '拉端服务-下载app按钮点击'
    }
};
// 不同的拉端方法
const openChannel = {
    // universal link / app link
    link: function (url) {
        locationCall(url);
    },
    scheme: function (url) {
        if (isIOSWithLocationCallSupport || isAndroidWithLocationCallSupport) {
            locationCall(url);
        }
        else {
            iframeCall(url);
        }
    },
    // 打开微信scheme
    wx_scheme: function (url) {
        if (isIOSWithLocationCallSupport || isAndroidWithLocationCallSupport) {
            locationCall(url);
        }
        else {
            iframeCall(url);
        }
    },
    // 下载
    download: function (linkObj, extra) {
        const { action, link } = linkObj;
        const { guidePageUrl, apkUrl } = extra || {};
        if (linkObj.cmd) {
            // 下载时如果配置口令，则自动复制
            utils.copy(linkObj.cmd);
            console.log('=======launchApp 口令复制成功=== ', linkObj.cmd);
        }
        switch (action) {
            case 'guide_download':
                // 跳转引导中间页
                if (guidePageUrl) {
                    locationCall(guidePageUrl);
                }
                else {
                    // 展示蒙层引导 引导用户去浏览器中打开活动页面
                    showGuideView();
                }
                break;
            case 'android_download': {
                // 安卓下载
                let url = link;
                if (apkUrl) {
                    url = apkUrl;
                }
                locationCall(url);
                break;
            }
            case 'ios_download':
                // ios下载
                locationCall(link);
                break;
            default:
                locationCall(link);
        }
    },
    // 拉端口令
    passphrase: showPassphraseView,
    // 调用快手和乘客端的bridge拉起微信小程序
    bridge: (data, browser) => {
        const { originalID, path, type } = data;
        if (!browser || browser === 'kuaishou') {
            window['callback_openWechatMiniProgram'] = (e) => {
                console.log('callback_openWechatMiniProgram====>', e);
            };
            const KwaiAdThird = window['KwaiAdThird'];
            if (KwaiAdThird) {
                KwaiAdThird.callAdBridge(JSON.stringify({
                    'action': 'openWechatMiniProgram',
                    'data': JSON.stringify({ originalID, path, type }),
                    'callback': 'callback_openWechatMiniProgram'
                })).then(res => {
                    console.log('调用成功！', res);
                }).catch(e => {
                    console.error('调用失败', e);
                });
            }
        }
        else if (browser === 'didi') {
            bridge.launchWeChatMiniApp({
                appId: originalID,
                path,
                programType: type,
            }, res => {
                if (res.errno === 0) {
                    console.log('调用成功！', res.errmsg);
                }
                else {
                    console.error('调用失败', res.errmsg);
                }
            });
        }
    }
};
// 进端事件上报埋点
export const trackLaunchAppAction = (deeplink) => {
    const params = {
        args: {
            url: getURL(),
            deeplink,
        },
        ...getLaunchAppCommonParams()
    };
    trackLaunchAppEvent(params, launchAppEnv);
};
// 拉端请求通用参数
const launchAppCommonParamsKey = [
    'entrance_channel',
    'prod_key',
    'dchn',
    'xpsid',
    'xpsid_from',
    'xpsid_root',
    'xbiz',
    'uid',
    'xenv',
    'xspm_from',
];
// 获取拉端通用参数
export const getLaunchAppCommonParams = () => {
    const urlParams = query();
    const nineChapterWebxParams = getNineChapterWebxParams();
    const params = {};
    launchAppCommonParamsKey.forEach(key => {
        params[key] = urlParams[key] || nineChapterWebxParams[key] || '';
    });
    return params;
};
// 拉端埋点
export const trackEvent = (eventId, data = {}) => {
    const launchAppCommonParams = getLaunchAppCommonParams();
    const { dchn, xpsid } = launchAppCommonParams;
    const params = {
        args: {
            event_id: eventId || '',
            page_url: window.location.href,
            dchn,
            ts: Date.now(),
            attrs: {
                ...data,
                xpsid,
                page_url: window.location.href,
            }
        },
        ...launchAppCommonParams,
    };
    try {
        upLaunchAppEvent(params, launchAppEnv);
        const omegaTrackInfo = launchEventIdToOmegaEventIdMap[eventId];
        if (!omegaTrackInfo)
            return;
        // 上报omega埋点
        const omegaParams = {
            ...data,
            ...launchAppCommonParams
        };
        track(omegaTrackInfo.eventId, omegaTrackInfo.label, omegaParams);
    }
    catch (error) {
        console.log('event up failed: ', error);
    }
};
export function getDeepLink(linkObj) {
    let link = linkObj.link;
    const extraParam = linkObj.extraParam || {};
    if (extraParam.originalID && extraParam.path) {
        link = extraParam.path; // 此时link为空，使用 extraParam.path
    }
    return link;
}
export const createElement = ({ label = 'div', className = '', style = {}, text = '', events = {}, props = {} }) => {
    const el = window.document.createElement(label);
    el.setAttribute('class', className);
    for (const key in style) {
        el.style[key] = toVw(style[key]);
    }
    for (const key in events) {
        el.addEventListener(key, events[key]);
    }
    for (const item in props) {
        el[item] = props[item];
    }
    el.innerText = text;
    return el;
};
// todo 后续提取为公共方法
// 只将rpx转换为vw
export const toVw = (num) => {
    if (String(num).match(/(\d*\.?\d+)rpx([\s;,)}]|$)/g)) {
        const ratio = `${100 / 750}`;
        return num.replace(/(\d*\.?\d+)rpx([\s;,)}]|$)/g, (...arg) => `${arg[1] * ratio}vw${arg[2]}`);
    }
    else {
        return num;
    }
};
export const formatInvokeAppConfig = (launchAppConfig) => {
    const { env, launchAppDchn, phone, invokePriority, invokeMode, keyboardToken, morePriority, isUseWeixinTag, isCopyCmd, cmdParams } = launchAppConfig;
    return {
        env,
        launchAppDchn,
        phone,
        invokeMode,
        invokePriority,
        keyboardToken,
        morePriority,
        isUseWeixinTag,
        isCopyCmd,
        cmdParams
    };
};
